import { Container } from "@mui/system";
import React, { useState } from "react";
import classes from "../ContactUs/ContactUs.module.css";

import Button from "@mui/material/Button";
import LandingPageNav from "../LandingPage/LandingPageNav";

const ContactUs = () => {
    const[email,setEmail]=useState()
    const[fname,setFname]=useState()
    const [lname,setLname]=useState()
    const [text,setText]=useState()

    
    const emailHandler=(event)=>{
        setEmail(event.target.value)
        console.log(event.target.value)

    }
    const fnameHandler=(event)=>{
        setFname(event.target.value)
        console.log(event.target.value)

    }
    const lnameHandler=(event)=>{
        setLname(event.target.value)
        console.log(event.target.value)

    }
    const textHandler=(event)=>{
        setText(event.target.value)
        console.log(event.target.value)

    }
    const formSubmitHandler=(event)=>{
        event.preventDefault()
        console.log(email,lname,fname,text)
    }



  return (
    <Container>
      <LandingPageNav />
      <div className={classes.contactPage}>
        <div className={classes.contactText}>
          <p>
            Getting in touch with us is not hard. We are a button click away.
            Just give us your email in the form below and we will get in touch
            with you in milliseconds (well! you don’t want us to freak you out)
            24 hours.
          </p>
        </div>
        <h4>Leave a message</h4>
        <br />
        <form onSubmit={formSubmitHandler}>
          <input className={classes.mail} type="mail" placeholder="Email" onChange={emailHandler} />
          <div className={classes.inputMiddle}>
            <input placeholder="First Name" type="text"  onChange={fnameHandler}/>
            <input placeholder="Last Name" type="text" onChange={lnameHandler} />
          </div>
          <br />
          <p>Let us know anything you want us to know before we contact you</p>
          <textarea
            onChange={textHandler}
            rows={6}
            cols={46}
            className={classes.text}
            placeholder="Note..."
          />
          <div className={classes.button}>
            <Button sx={{width:"100%"}} variant="contained" type="submit">
              Submit
            </Button>
          </div>
        </form>
      </div>
    </Container>
  );
};

export default ContactUs;
